import { MessagesSquare } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Spinner } from '@/components/ui'
import { ModuleEmptyPage } from '@/components/layout/ModuleEmptyPage'
import { useCurrentTenant } from '@/features/tenants/useCurrentTenant'

import { WebChatChannelList } from './components/WebChatChannelList'

/**
 * Tela de WebChat (ADR-026 Fatia 5): o admin cria e configura os widgets embutíveis — publishable key, signing
 * secret (mostrado uma vez), origens autorizadas — e copia o snippet de embed. Vocabulário neutro: nunca expõe
 * infraestrutura.
 */
export function WebChatPage() {
  const { t } = useTranslation()
  const { tenant, isLoading } = useCurrentTenant()

  if (isLoading) {
    return (
      <div className="flex justify-center py-12">
        <Spinner label={t('loading')} />
      </div>
    )
  }

  if (tenant === null) {
    return (
      <ModuleEmptyPage
        icon={MessagesSquare}
        title={t('webchat.pageTitle')}
        description={t('webchat.pageSubtitle')}
      />
    )
  }

  return (
    <div className="mx-auto flex w-full max-w-4xl flex-col gap-6">
      <header className="flex flex-col gap-1">
        <h1 className="text-xl font-semibold text-foreground-primary">{t('webchat.pageTitle')}</h1>
        <p className="text-sm text-foreground-muted">{t('webchat.pageSubtitle')}</p>
      </header>
      <WebChatChannelList tenantId={tenant.id} />
    </div>
  )
}
